// Configuración de la API
// Si existe REACT_APP_API_URL en las variables de entorno, lo usa
// Si no, usa localhost por defecto para desarrollo

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default API_URL;

